import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy, signal } from '@angular/core';
import { Observable, Subject, map } from 'rxjs';
import { ApiService } from './api.service';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceService implements OnDestroy {
  private headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
  private readonly updateWorkspaceNameEventSubject = new Subject<string>();
  public workSpaceSettings = signal<any>(null);

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private tokenService: TokenService,
  ) {}

  updateWorkspaceEvent$ = this.updateWorkspaceNameEventSubject.asObservable();

  public getWorkspace(uuid: string): Observable<any> {
    return this.http
      .get(this.apiService.getWorkspaceDetails(uuid), { headers: this.headers })
      .pipe(map((res) => res || {}));
  }

  public updateWorkspaceName(workspaceName: { name: string }, uuid: string): Observable<any> {
    return this.http.patch<any>(this.apiService.getWorkspaceDetails(uuid), workspaceName, { headers: this.headers });
  }

  public getWorkspaceSettings(uuid: string): Observable<any> {
    return this.http.get(this.apiService.getWorkspaceSettingsUrl(uuid), { headers: this.headers });
  }

  public updateWorkspaceSettings(settings: any, uuid: string): Observable<any> {
    return this.http.patch<any>(this.apiService.getWorkspaceSettingsUrl(uuid), settings, { headers: this.headers });
  }

  public eventUpdateWorkspaceName(workspaceName: string): void {
    this.updateWorkspaceNameEventSubject.next(workspaceName);
  }

  public createNewWorkspace(workspaceName: string): Observable<any> {
    return this.http.post(this.apiService.getWorkspacesUrl(), { name: workspaceName }, { headers: this.headers });
  }

  public activateNewWorkspace({ userUUID, companyUUID }: { userUUID: string; companyUUID: string }): Observable<any> {
    return this.http.post(
      this.apiService.getActivateWorkspaceUrl(),
      { company: { uuid: companyUUID }, user: { uuid: userUUID } },
      { headers: this.headers },
    );
  }

  ngOnDestroy(): void {
    // ✅ Ensure no lingering subscriptions by completing the Subject
    this.updateWorkspaceNameEventSubject.complete();
  }
}
